// extracted by mini-css-extract-plugin
export default {"card":"styles_card__q6piz","title":"styles_title__Dpx0z","text":"styles_text__SfHUm","button":"styles_button__fTsNj","button_text":"styles_button_text__GFIfj"};